import { Swiper } from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

common.View.create('website_news::canvas.blocks.modules.news.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        const swiperElement = this.element.find('.news-swiper');

        if (swiperElement.length === 0) {
            return;
        }

        const nextButton = swiperElement.find('.swiper-button-next').get(0);

        if (!nextButton) {
            return;
        }

        new Swiper(swiperElement.get(0), {
            modules: [Navigation, Autoplay],
            loop: false,
            spaceBetween: 20,
            slidesPerView: 1,
            navigation: {
                nextEl: nextButton,
            },
            autoplay: false,
        });
    }
});
